import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, TextField, Tooltip, Typography } from '@mui/material';
import { addExceptionToAcceptanceApi, updateExceptionToAcceptanceApi } from '../apiServices';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { useSnackbar } from 'notistack';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { trackActivity } from '../../../../utils/mixpanel';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { useDispatch, useSelector } from 'react-redux';
import { formatBytes } from '../../../../utils/fileUpload';
import { regexConstants } from '../../../../constants/regEx';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { backendDateFormat, dayMonthDateFormat, fieldDateFormat } from '../../../../constants';
import moment from 'moment';
import { getCurrencyApi } from '../../security_deposit/apiService';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';


const ExceptionToAcceptanceCRU = ({ addEditExcepToAccep, fileUpload, onToggleModal, getResponseBack, params, onOpenAttachments, modeType }) => {
    const dispatch = useDispatch()
    const [error, setError] = useState({});
    const { storageDetails } = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false);
    const [exceptionToAcceptanceData, setExceptionToAcceptanceData] = useState(addEditExcepToAccep?.data);
    const [uploadedFilels, setUploadedFiles] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [dropDownloader, setDropDownLoader] = useState({ currency: false, status: true })
    const [pltConstants, setPltConstants] = useState({ constant_types: [], asset_types: [], currencies: [] });

    useEffect(() => {
        getCurrency();
    }, []);

    const getCurrency = () => {
        setDropDownLoader(prev => ({ ...prev, currency: true }))
        globalGetService(getCurrencyApi(params))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, currency: false, status: false }))
                if (checkApiStatus(response)) {
                    setPltConstants(prevConstants => ({
                        ...prevConstants,
                        currencies: response.data.data || []
                    }));
                }
            })
    }

    const onAddEditExceptionToAcceptance = () => {
        let validationInputs = {};
        validationInputs = { 
            name: exceptionToAcceptanceData?.name ? "" : "Please enter Name",
            currency: exceptionToAcceptanceData?.currency ? "" : "Please enter Currency"
        };

        const expDate = moment(exceptionToAcceptanceData.date);
        const completionDate = moment(exceptionToAcceptanceData.completion_date);
        if(exceptionToAcceptanceData.date && !expDate.isValid()) {
            validationInputs.date = "Please enter valid Date";
        }
        if(exceptionToAcceptanceData.completion_date && !completionDate.isValid()) {
            validationInputs.completion_date = "Please enter valid Completion Date";
        }

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, exceptionToAcceptanceData);
             payload = {
                ...payload,
                currency: exceptionToAcceptanceData?.currency?.code || "",
            }
            if (exceptionToAcceptanceData.id) {
                globalPutService(updateExceptionToAcceptanceApi({ ...params, slug: exceptionToAcceptanceData?.slug }), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (uploadedFilels?.length > 0) {
                                fileUpload(exceptionToAcceptanceData.slug,'updated')
                            }
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Exception to Acceptance`, success_msg: response?.data?.message, item_id: exceptionToAcceptanceData?.id, payload: exceptionToAcceptanceData, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                            trackActivity('Item Edited', { page_title: `Edit Exception to Acceptance`, error_msg: response?.data?.message, item_id: exceptionToAcceptanceData?.id, payload: exceptionToAcceptanceData, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addExceptionToAcceptanceApi({ leaseSlug: params?.leaseSlug }), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (uploadedFilels?.length > 0) {
                                fileUpload(response?.data?.data.slug,'created')
                            }
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, {
                                variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }
                            })
                            trackActivity('Item Added', { page_title: `Add Exception to Acceptance`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: exceptionToAcceptanceData, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, {
                                variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }
                            })
                            trackActivity('Item Added', { page_title: `Add Exception to Acceptance`, error_msg: response?.data?.message, item_id: null, payload: exceptionToAcceptanceData, response: response?.data })
                        }
                    })
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Exception to Acceptance`, error_msg: validationInputs, })
        }
    };

    const handelInputChange = (key, value) => {
        setExceptionToAcceptanceData({ ...exceptionToAcceptanceData, [key]: value })
    }

    const handleFileChange = (files) => {
        setUploadedFiles(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Exception to Acceptance`, page_type: page_type, })
    }

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth
                open={addEditExcepToAccep.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? "Add Exception To Acceptance" : modeType === 'edit' ? 'Edit Exception To Acceptance' : 'View Exception To Acceptance'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='name'
                                label="Name"
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                required
                                value={exceptionToAcceptanceData.name}
                                error={error.name}
                                disabled={modeType === "view"}
                                helperText={error.name}
                                slotProps={{
                                    inputLabel: { shrink: true },
                                    htmlInput: {
                                        maxLength: 100,
                                    }
                                }}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("name", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, name: "" }));
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='component'
                                label="Component"
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100}}}
                                value={exceptionToAcceptanceData.component ?? ""}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("component", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, component: "" }));
                                }}
                                disabled={modeType === "view"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='reference'
                                label="Reference"
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100}}}
                                value={exceptionToAcceptanceData.reference ?? ""}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("reference", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, reference: "" }));
                                }}
                                disabled={modeType === "view"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={ modeType === "view" ? exceptionToAcceptanceData?.currency ? [exceptionToAcceptanceData.currency] : [] : pltConstants?.currencies || [] }
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option.name || ""}
                                value={ modeType === "view" ? exceptionToAcceptanceData?.currency || null : pltConstants?.currencies?.find( item => item?.code === exceptionToAcceptanceData?.currency?.code ) || null }
                                onChange={(e, value) => handelInputChange("currency", value)}
                                noOptionsText={dropDownloader?.currency ? "Loading..." : "No Option Available"}
                                onFocus={() => onRestErrorKey("currency")}
                                isOptionEqualToValue={(option, value) => option.code === value.code}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                required
                                                {...params}
                                                label="Currency"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.currency)}
                                                helperText={error.currency}
                                                disabled={modeType === 'view'}
                                                slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: ( <> {modeType !== "view" && dropDownloader?.currency && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </> ) } }}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='amount'
                                label="Amount"
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 20 }, input: { startAdornment: (<InputAdornment position="start">{exceptionToAcceptanceData?.currency?.symbol}</InputAdornment>) }}} 
                                value={exceptionToAcceptanceData.amount ?? ""}
                                onChange={(e) => {
                                    regexConstants.decimalnodotstart.test(e.target.value) || e.target.value === "" ? handelInputChange("amount", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, amount: "" }));
                                }}
                                disabled={modeType === "view"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Date"
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true }, size: "small", margin: "normal", 
                                            error: error.date || false,
                                            helperText: error.date || '',
                                            onFocus: () => { error.date && onRestErrorKey("date"); },
                                        },
                                        field: { clearable: true, onClear: () => { handelInputChange("date", null); } },
                                    }}
                                    sx={{ width: "100%" }}
                                    disabled={modeType === 'view'}
                                    format={fieldDateFormat}
                                    value={exceptionToAcceptanceData?.date ? moment(exceptionToAcceptanceData?.date) : null}
                                    onChange={(value) => {
                                        const isValid = moment(value)?.isValid();
                                        handelInputChange("date", value ? moment(value).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("date");
                                        }
                                    }}        
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Completion Date"
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.completion_date || false,
                                            helperText: error.completion_date || '',
                                            onFocus: () => { error.completion_date && onRestErrorKey("completion_date"); },
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                handelInputChange("completion_date", null);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    disabled={modeType === 'view'}
                                    format={fieldDateFormat}
                                    value={exceptionToAcceptanceData?.completion_date ? moment(exceptionToAcceptanceData?.completion_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        handelInputChange("completion_date", data ? moment(data).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("completion_date");
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Autocomplete
                                disabled={modeType === "view"}
                                options={["Open", "Closed"]}
                                getOptionLabel={(option) => option || ""}
                                value={exceptionToAcceptanceData?.status || null}
                                onChange={(e, value) => handelInputChange("status", value)}
                                noOptionsText={dropDownloader?.status ? "Loading..." : "No Option Available"}
                                size="small"
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        variant="outlined"
                                        size="small"
                                        margin="normal"
                                        slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: ( <> {modeType !== "view" && dropDownloader?.status && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </> ), }, }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='significant'
                                label="Significant"
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100}}}
                                value={exceptionToAcceptanceData.significant ?? ""}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("significant", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, significant: "" }));
                                }}
                                disabled={modeType === "view"}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={exceptionToAcceptanceData?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ xs: 12, md: 12 }}>
                                <TextField
                                    id='remark'
                                    label="Remarks"
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    disabled={modeType === "view"}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    value={exceptionToAcceptanceData?.remarks ?? ""}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, remarks: "" }));
                                    }}
                                />
                            </Grid>}
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Description' value={exceptionToAcceptanceData?.description || ""} />
                        </Grid> :
                            <Grid size={{ xs: 12, md: 12 }}>
                                <TextField
                                    id='description'
                                    label="Description"
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    value={exceptionToAcceptanceData.description ?? ""}
                                    disabled={modeType === "view"}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("description", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, description: "" }));
                                    }}
                                    slotProps={{ inputLabel: { shrink: true } }} />
                            </Grid>}
                        <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                                {
                                    exceptionToAcceptanceData?.id && exceptionToAcceptanceData?.attachments?.length ? <Button size='small' variant='outlined' color="primary" sx={{ marginBottom: '10px' }}
                                        onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }}>
                                        {`${exceptionToAcceptanceData.attachments.length}: Attachments`}
                                    </Button> : null
                                }
                                <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {
                                modeType === "view" ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={exceptionToAcceptanceData?.attachments} remainingStorage={storageDetails?.remaining_storage} />
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> {modeType === "view" ? "Close" : "Cancel"} </Button>
                    {modeType === "view" ? null : <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditExceptionToAcceptance() }} disabled={modeType === "view"}> {isLoading ? <CircularProgress color='inherit' size={24} /> : "Save"} </Button>}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ExceptionToAcceptanceCRU;
